<div class="mt-2" *ngFor="let variantCatalogDataItem of variantCatalog">
  <app-variant-catalog-filter-item [variantCatalogDataItem]="variantCatalogDataItem"
                                   (filterChange)="processFilterChangeEvent($event)">
  </app-variant-catalog-filter-item>
</div>
